"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SystemLogger = void 0;
var Logger_1 = require("./Logger");
Object.defineProperty(exports, "SystemLogger", { enumerable: true, get: function () { return Logger_1.SystemLogger; } });
//# sourceMappingURL=index.js.map